module.exports = __webpack_public_path__ + "static/media/intro.1cbed6d1.mp3";